import { endpoint } from '../decorators/endpoint.decorator';
import { BaseViewModel } from './base-view-model';

@endpoint('population')
export class IDWViewModel extends BaseViewModel {
  public HawkId = '';
  public Title = '';
  public Department = '';
  public Email = '';
  public First = '';
  public Middle = '';
  public Last = '';
  public get LastFirst(): string {
    return `${this.Last}, ${this.First} ${this.Middle || ''}`;
  }
}
